import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LocaleHandler {
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const locale = this.router.parseUrl(this.router.url).queryParams['locale'];
      if (locale) {
        const safeLocale = environment.I18N_CONFIG.supportedLocales.includes(locale)
          ? locale
          : environment.I18N_CONFIG.defaultLocale;
        this.translateService.use(safeLocale);
      }
    });
  }
}
